import { useContext, useEffect, useState } from "react"
import { getData } from "src/actions/getData";
import MiniInfoButton from "src/components/MiniInfoButton";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import shopContext from "src/context/shopContext";
import { numberWithCommas } from "src/utils/thousandSeprator";
import { TbEyeSearch } from "react-icons/tb";
import { RxExternalLink } from "react-icons/rx";
import { PiNote } from "react-icons/pi";
import { LiaShippingFastSolid } from "react-icons/lia";
import { TbMapPinCog } from "react-icons/tb";
import { TbReload } from "react-icons/tb";
import { PiBarcode } from "react-icons/pi";
import Modal from "src/components/Modal";
import ModalHeader from "src/components/Modal/ModalHeader";
import ModalBody from "src/components/Modal/ModalBody";
import ModalFooter from "src/components/Modal/ModalFooter";
import TwinButton from "src/components/TwinButton";
import FilterColumn from "src/components/Table/FilterColumn";
import { FilterFn } from "src/components/Table/FilterFn";
import { FiEdit } from "react-icons/fi";
import Select from "react-select";
import moment from 'jalali-moment';
import { expressShippingTitle, orderStatusOptions } from "src/settings/config";
import { get, post } from "src/services/HttpClient";
import CatchyCheckbox from "src/components/CatchyCheckbox";
import { notify } from "src/services/Notification/Notification";
import PermissionBasedComponent from "src/components/PermissionBasedComponent";
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import ParcelUI from "src/components/ParcelUI";
import Hintbox from "src/components/Hintbox";
import { TbHelpSquareRounded } from "react-icons/tb";
import Accordion from "src/components/Accordion";
import Spinner from "src/components/Spinner";
import { convertToIranLocalNumber } from "src/utils/convertToIranLocalNumber";
import { Formik, Form } from "formik";
import FormikField from "src/components/FormikField/FormikField";
import { put } from "src/services/HttpClient/HttpClient";
import UpdateOrderModal from "./UpdateOrderModal";

export default function Orders() {

    const { orders, setOrders } = useContext(shopContext)
    useEffect(() => {
        const controller = new AbortController(); // برای لغو درخواست
        const signal = controller.signal;

        if (!orders) {
            getData(setOrders, "/orders?limit=100000", {}, signal);
        }

        return () => {
            controller.abort();
        };
    }, [])


    const [rowData, setRowData] = useState()
    const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false)
    const [isEditModalOpen, setIsEditModalOpen] = useState(false)
    const [isPrintModalOpen, setIsPrintModalOpen] = useState(false)
    const [isBarcodeModalOpen, setIsBarcodeModalOpen] = useState(false)
    const [isEditAddressModalOpen, setIsEditAddressModalOpen] = useState(false)
    const [isNoteModalOpen, setIsNoteModalOpen] = useState(false)
    const [barcodeLoading, setBarcodeLoading] = useState(false)
    const [parcelData, setParcelData] = useState()
    const [noteData, setNoteData] = useState()
    const [loadingParcelData, setLoadingParcelData] = useState(false)
    const [packageSize, setPackageSize] = useState(null)
    const [isCollectiveEditModalOpen, setIsCollectiveEditModalOpen] = useState(false)
    const [selectedOrderStatus, setSelectedOrderStatus] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [step, setStep] = useState(1)
    const [confirm, setConfirm] = useState(false)
    const [selectedOrders, setSelectedOrders] = useState(false)

    const receiptRef = useRef(null);
    const reactToPrintFn = useReactToPrint({
        contentRef: receiptRef,
    });

    const parcelRef = useRef(null)
    const reactToPrintParcelFn = useReactToPrint({
        contentRef: parcelRef,
    });

    useEffect(() => {
        if (!isNoteModalOpen) {
            setNoteData(null)
        }
    }, [isNoteModalOpen])


    useEffect(() => {
        setSelectedOrderStatus(orderStatusOptions.filter(option => option.value == rowData?.status)?.[0])
    }, [rowData, isEditModalOpen])

    useEffect(() => {
        if (!isEditModalOpen) {
            setStep(1)
            setConfirm(false)
        }
    }, [isEditModalOpen])

    useEffect(() => {
        if (isPrintModalOpen) {
            reactToPrintFn()
            setIsPrintModalOpen(false)
        }
    }, [isPrintModalOpen])

    useEffect(() => {
        if (!isBarcodeModalOpen) {
            setParcelData(null)
            setLoadingParcelData(false)
        }
    }, [isBarcodeModalOpen])


    const columns = [
        {
            id: "orderNumber",
            cell: (info) => info.getValue(),
            header: "شماره سفارش",
        },
        {
            id: "transactionId",
            cell: (info) => info.getValue(),
            header: "شماره تراکنش",
        },
        {
            id: "receiverName",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "تحویل گیرنده",
        },
        {
            id: "receiverPhone",
            cell: (info) => info.getValue() ? <p style={{ direction: "ltr" }}>{info.getValue()}</p> : "---",
            header: "شماره تماس",
            inTable: false,
            inExport: true
        },
        {
            id: "email",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "ایمیل",
            inTable: false,
            inExport: true
        },
        {
            id: "totalAmount",
            cell: (info) => info.getValue() ? numberWithCommas(info.getValue()) + " تومان" : "---",
            header: "مبلغ سفارش",
        },
        {
            id: "status",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "وضعیت سفارش",
        },
        {
            id: "paymentMethod",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "درگاه",
        },
        {
            id: "province",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "استان",
            inExport: false,
        },
        {
            id: "city",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شهر",
            inExport: false,
        },
        {
            id: "address",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "آدرس تحویل",
        },
        {
            id: "shippingName",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شیوه ارسال",
            inExport: false
        },
        {
            id: "receiverPhone",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شماره تماس گیرنده",
            inExport: false,
            permission: "viewOrdersPhoneNumber"
        },
        // {
        //     id: "referrer",
        //     cell: (info) => info.getValue() ? info.getValue() : "---",
        //     header: "منبع",
        // },
        {
            id: "note",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "یادداشت مشتری",
        },
        {
            id: "createdAt",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "تاریخ ایجاد",
            inTable: false,
        },
        {
            id: "createdAt",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue(), "en", "YYYY-MM-DD HH:mm:ss")
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            filterFn: (row, columnId, filterValue) => {
                // type can be "object" , "array" , "string" , "number"
                return FilterFn(row, columnId, filterValue, "date");
            },
            meta: {
                filterComponent: (setFilterValue, column, table, backendFilters, setBackendFilters) => {
                    return <FilterColumn setFilterValue={setFilterValue} column={column} table={table} backendFilters={backendFilters} setBackendFilters={setBackendFilters} type="date" />;
                },
            },
            header: "تاریخ ایجاد",
            inExport: false,
        },
        {
            id: "id",
            cell: (info) => (
                <div className="flex gap-2">

                    {
                        (info.row.original.city != "تهران" && "pws-post,completed,completed-service,pws-courier,pws-packaged,processing".includes(info.row.original.status))
                        &&
                        <div
                            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-700 text-gray-400 p-2 rounded-lg"
                            onClick={async () => {
                                setRowData(info.row.original)
                                setIsBarcodeModalOpen(true)
                                setLoadingParcelData(true)
                                await getData(setParcelData, `epost/parcel/${info.row.original.id}`)
                                setLoadingParcelData(false)
                            }}
                            title="ثبت بارکد پستی"
                        >
                            <PiBarcode className="text-purple-500" />
                        </div>
                    }
                    <div
                        className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-700 text-gray-400 p-2 rounded-lg"
                        onClick={() => {
                            setRowData(info.row.original)
                            setIsPrintModalOpen(true)
                        }}
                    >
                        <LiaShippingFastSolid className="text-green-500" />
                    </div>
                    <div
                        className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-700 text-gray-400 p-2 rounded-lg"
                        onClick={() => {
                            setRowData(info.row.original)
                            setIsDetailsModalOpen(true)
                        }}
                    >
                        <TbEyeSearch className="text-blue-500" />
                    </div>
                    <PermissionBasedComponent permission="changeOrdersStatus">
                        <div
                            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-700 text-gray-400 p-2 rounded-lg"
                            onClick={() => {
                                setRowData(info.row.original)
                                setIsEditModalOpen(true)
                            }}
                        >
                            <FiEdit className="text-red-500" />
                        </div>
                    </PermissionBasedComponent>
                    <div
                        className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-700 text-gray-400 p-2 rounded-lg"
                        onClick={async () => {
                            setRowData(info.row.original)
                            setIsNoteModalOpen(true)
                            await getData(setNoteData, `orders/${info.row.original.id}/history`)
                        }}
                    >
                        <PiNote className="text-yellow-500" />
                    </div>
                    <div
                        className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-700 text-gray-400 p-2 rounded-lg"
                        onClick={() => {
                            setRowData(info.row.original)
                            setIsEditAddressModalOpen(true)
                        }}
                    >
                        <TbMapPinCog className="text-slate-500" />
                    </div>

                </div>
            ),
            header: "عملیات",
            footer: (info) => info.column.id,
            inExport: false,
            enableColumnFilter: false,
            permission: "viewOrdersOperation"
        },
        {
            id: "address",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "آدرس تحویل",
            inTable: false,
        },
        {
            id: "province",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "استان",
            inTable: false,
        },
        {
            id: "city",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شهر",
            inTable: false,
        },
        {
            id: "postcode",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "کدپستی",
            inTable: false,
        },
        {
            id: "phoneNumber",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شماره تماس گیرنده",
            inTable: false,
        },

        {
            id: "id",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "شماره شناسایی مرسوله",
            inTable: false,
        },
        {
            id: "shipping_title",
            cell: (info) => info.getValue() ? info.getValue() : "---",
            header: "نحوه ارسال",
            inTable: false,
        },
    ];

    return (
        <>
            <PageHeader
                title="لیست سفارش‌ها"
            // btnTitle="بروزرسانی"
            // handleClick={async () => {
            //     setOrders();
            //     await get("/orders/purgeCache")
            //     setTimeout(() => {
            //         getData(setOrders, "/orders");
            //     }, 500);
            // }}
            // btnIcon={<TbReload className="ml-1" size="20" />}
            // isBtnLoading={!orders}
            >
                <PermissionBasedComponent permission="changeOrdersStatus">
                    {
                        (selectedOrders && selectedOrders?.rows?.length > 1)
                            ?
                            <button
                                className="h-[48px] shadow-lg text-sm flex-1 w-full flex justify-center p-3 py-2 md:p-6 md:py-3 rounded-lg text-white bg-purple-500 opacity-90 hover:opacity-100 transition-all ease-in-out duration-200"
                                onClick={() => setIsCollectiveEditModalOpen(true)}
                            >
                                ویرایش دسته جمعی ({selectedOrders?.rows?.length})
                            </button>
                            :
                            <></>
                    }
                </PermissionBasedComponent>
            </PageHeader>

            <Accordion title="نکات راهنما" icon={<TbHelpSquareRounded className="text-gray-400" />} hasVerticalLine={true} >
                {/* <Hintbox text="لیست آخرین سفارش های دریافتی(سبدهای خرید) به ترتیب تاریخ - تنها در صورت عدم دریافت صحیح اطلاعات از دکمه بروزرسانی در بالای صفحه استفاده کنید." type="info" /> */}
                <Hintbox text="برای ویرایش دسته جمعی وضعیت سفارش‌ها، لازم است حداقل 2 سفارش را انتخاب کنید." type="alert" />
            </Accordion>

            <Table
                data={orders}
                // requestPath="ordersPages"
                // setRequestData={setOrders}
                columns={columns}
                isSelective={true}
                setSelected={setSelectedOrders}
                CSVExportPermission="exportOrders"
            />

            <Modal isOpen={false} toggle={setIsPrintModalOpen} width={1400}>
                <ModalHeader>پرینت لیبل پستی</ModalHeader>
                <ModalBody>
                    <div className="p-4 post-label" ref={receiptRef} style={{ direction: "rtl", width: "100%", margin: 0 }}>
                        <div className="template-1 container">
                            <div className="flex justify-center items-center border border-gray-500 bg-white">
                                <div className="flex gap-2 flex-col p-4 flex-1">
                                    <div>
                                        <span className="font-bold">گیرنده:</span> {rowData?.province}، {rowData?.city}، {rowData?.address}
                                    </div>
                                    <div>
                                        <span className="font-bold">نام کامل:</span> {rowData?.receiverName}
                                    </div>
                                    <div>
                                        <span className="font-bold">کد پستی:</span> {rowData?.postalCode}
                                    </div>
                                    <div>
                                        <span className="font-bold">تلفن:</span> {rowData?.receiverPhone}
                                    </div>
                                    <div>
                                        <span className="font-bold">تاریخ سفارش:</span>
                                        {rowData?.createdAt
                                            ? moment
                                                .from(rowData?.createdAt, "en", "YYYY-MM-DD HH:mm:ss")
                                                .locale("fa")
                                                .format("jYYYY/jMM/jDD HH:mm")
                                            : "---"}
                                    </div>
                                    {
                                        rowData?.note
                                        &&
                                        <div>
                                            <span className="font-bold">یادداشت مشتری:</span> {rowData?.note}
                                        </div>
                                    }
                                </div>
                                <div className="flex gap-2 flex-col p-4 flex-1 border-r border-gray-500">
                                    <div>
                                        <span className="font-bold">فرستنده: بدورژ</span>
                                    </div>
                                    <div>
                                        <span className="font-bold">آدرس:</span> تهران، اشرفی اصفهانی شمال، بالاتر از میدان پونک، خیابان رمضانی، پلاک 26 واحد 7
                                    </div>
                                    <div>
                                        <span className="font-bold">کد پستی:</span> 1469653148
                                    </div>
                                    <div>
                                        <span className="font-bold">تلفن:</span> ۰۲۱۹۱۰۰۷۲۷۹
                                    </div>
                                    <div>
                                        <span className="font-bold">ایمیل:</span> info@bodoroj.com
                                    </div>
                                    <div>
                                        <span className="font-bold">وبسایت:</span> https://bodoroj.com
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle="چاپ لیبل"
                        acceptHandle={() => { reactToPrintFn() }}
                        rejectHandle={() => { setIsPrintModalOpen(false) }}
                        rejectTitle="بستن"
                        isCompact={true}
                    />
                </ModalFooter>
            </Modal>

            <Modal isOpen={isEditModalOpen} toggle={setIsEditModalOpen}>
                <ModalHeader>ویرایش وضعیت سفارش</ModalHeader>
                <ModalBody>
                    <div className="p-4 flex flex-col gap-4">
                        <div>شما در حال ویرایش سفارش <span className="font-bold">{rowData?.orderNumber}</span> به نام <span className="font-bold">{rowData?.receiverName}</span> هستید.</div>
                        <Select
                            name="order-status"
                            value={selectedOrderStatus}
                            // defaultValue={orderStatusOptions[0]}
                            className="al-dashboard"
                            // isMulti
                            isDisabled={false}
                            isClearable
                            placeholder="وضعیت صحیح را انتخاب کنید"
                            options={orderStatusOptions}
                            onChange={(selectedOption) => {
                                setSelectedOrderStatus(selectedOption)
                                setConfirm(false)
                                if (selectedOption?.value != rowData?.status) {
                                    setStep(2)
                                }
                            }}
                        />
                        {
                            step == 2
                            &&
                            <div className="flex">
                                <CatchyCheckbox
                                    label={<div>تایید تغییر وضعیت از <span className="font-bold">{orderStatusOptions.find(item => item.value == rowData?.status)?.label}</span> به <span className="font-bold">{selectedOrderStatus?.label}</span></div>}
                                    isActive={confirm}
                                    handleCheck={() => setConfirm(true)}
                                />
                            </div>
                        }
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle={confirm ? "ذخیره تغییرات" : false}
                        acceptHandle={async () => {
                            if(rowData.paymentMethod==="snapppay"){
                                const confirmed = window.confirm("تغییر وضعیت سفارشی که با اسنپ پی پرداخت شده غیر قابل بازگشت است، آیا از انجام این عملیات اطمینان دارید؟ ");
                                if (!confirmed) return;
                            }

                            setIsLoading(true)
                            let result = await put(`/orders/${rowData?.id}/status`, {
                                status: selectedOrderStatus?.value
                            })
                            if (result.statusCode == 200) {
                                notify("وضعیت سفارش با موفقیت تغییر یافت")
                            } else {
                                notify("خطایی رخ داده است", "error")
                            }
                            setIsLoading(false)
                            setIsEditModalOpen(false)
                            setOrders(orders.map(order => {
                                if (order.id == rowData.id) {
                                    return {
                                        ...order,
                                        status: selectedOrderStatus?.value,
                                        statusFa: orderStatusOptions.filter(option => option.value == selectedOrderStatus?.value)?.[0]?.label,
                                    }
                                } else {
                                    return {
                                        ...order
                                    }
                                }
                            }))
                        }}
                        rejectHandle={() => { setIsEditModalOpen(false); setStep(1) }}
                        rejectTitle="بستن"
                        isCompact={true}
                        isLoading={isLoading}
                    />
                </ModalFooter>
            </Modal>

            <UpdateOrderModal rowData={rowData} isModalOpen={isDetailsModalOpen} setIsModalOpen={setIsDetailsModalOpen} />

            <Modal isOpen={isCollectiveEditModalOpen} toggle={setIsCollectiveEditModalOpen}>
                <ModalHeader>ویرایش دسته جمعی {selectedOrders?.rows?.length} سفارش</ModalHeader>
                <ModalBody>
                    <div className="p-4 flex flex-col gap-4">
                        <div>شما در حال ویرایش سفارش‌های <span className="font-bold">{selectedOrders && selectedOrders?.rows?.map(order => order?.original?.orderNumber).join(" , ")}</span> هستید.</div>
                        <Select
                            name="order-status"
                            value={selectedOrderStatus}
                            // defaultValue={orderStatusOptions[0]}
                            className="al-dashboard"
                            // isMulti
                            isDisabled={false}
                            isClearable
                            placeholder="وضعیت صحیح را انتخاب کنید"
                            options={orderStatusOptions}
                            onChange={(selectedOption) => {
                                setSelectedOrderStatus(selectedOption)
                                setConfirm(false)
                                if (selectedOption?.value != rowData?.status) {
                                    setStep(2)
                                }
                            }}
                        />
                        {
                            step == 2
                            &&
                            <div className="flex">
                                <CatchyCheckbox
                                    label={<div>تایید تغییر وضعیت کلی تمام سفارش ها به <span className="font-bold">{selectedOrderStatus?.label}</span></div>}
                                    isActive={confirm}
                                    handleCheck={() => setConfirm(true)}
                                />
                            </div>
                        }
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle={confirm ? "ذخیره تغییرات" : false}
                        acceptHandle={async () => {
                            setIsLoading(true)
                            let ordersIDs = selectedOrders?.rows?.map(order => order?.original?.id)
                            let results = []
                            for (let index = 0; index < ordersIDs.length; index++) {
                                let result = await put(`/orders/${ordersIDs[index]}`, {
                                    status: selectedOrderStatus?.value
                                })
                                results.push(result.statusCode == 200 ? true : false)
                            }
                            if (results.includes(false)) {
                                notify("در بروزرسانی برخی سفارش ها خطا رخ داده است", "error")
                            } else {
                                notify("وضعیت تمامی سفارش ها تغییر کرد")
                            }
                            setIsLoading(false)
                            setIsCollectiveEditModalOpen(false)
                            setStep(1)
                            setOrders(orders.map(order => {
                                if (ordersIDs.includes(order.id)) {
                                    return {
                                        ...order,
                                        status: selectedOrderStatus?.value,
                                        statusFa: orderStatusOptions.filter(option => option.value == selectedOrderStatus?.value)?.[0]?.label,
                                    }
                                } else {
                                    return {
                                        ...order
                                    }
                                }
                            }))
                        }}
                        isCompact={true}
                        rejectTitle="بستن"
                        isLoading={isLoading}
                        rejectHandle={() => { setIsCollectiveEditModalOpen(false); setStep(1) }}
                    />
                </ModalFooter>
            </Modal>

            <Modal isOpen={isBarcodeModalOpen} toggle={setIsBarcodeModalOpen}>
                <ModalHeader>ثبت بارکد پستی</ModalHeader>
                <ModalBody>
                    {
                        parcelData
                            ?
                            <div ref={parcelRef} style={{ direction: "rtl" }}>
                                <ParcelUI orderData={rowData} parcelData={parcelData} />
                            </div>
                            :
                            loadingParcelData
                                ?
                                <Spinner />
                                :
                                <div className="w-full flex flex-col gap-3 p-4">
                                    <span>
                                        لطفا با توجه به اقلام موجود در سفارش، سایز بسته پستی را انتخاب کنید
                                    </span>
                                    <div>
                                        <label htmlFor="">سایز جعبه</label>
                                        <Select
                                            placeholder="سایز مناسب بسته پستی را انتخاب کنید"
                                            options={[
                                                { value: 1, label: "بسته سایز 1: 150*100*100 mm" },
                                                { value: 2, label: "بسته سایز 2: 200*150*100 mm" },
                                                { value: 3, label: "بسته سایز 3: 200*200*150 mm" },
                                                { value: 4, label: "بسته سایز 4: 300*200*200 mm" },
                                                { value: 5, label: "بسته سایز 5: 350*250*200 mm" },
                                                { value: 6, label: "بسته سایز 6: 450*250*200 mm" },
                                                { value: 7, label: "بسته سایز 7: 400*300*250 mm" },
                                                { value: 8, label: "بسته سایز8: 450*400*300 mm" },
                                                { value: 9, label: "بسته سایز9: 550*450*350 mm" },
                                            ]}
                                            onChange={(selectedOption) => { setPackageSize(selectedOption.value) }}
                                            className="al-dashboard"
                                        />
                                    </div>
                                    {

                                        rowData?.orderItems && rowData?.orderItems.map(item => {
                                            return (
                                                <div className="p-2 flex flex-col lg:flex-row items-center justify-between gap-2 w-full border border-gray-200 rounded-xl">
                                                    <div className="flex flex-col lg:flex-row gap-3 items-center">
                                                        <img className="w-14 border border-gray-100 rounded-xl" src={`${process.env.REACT_APP_CDN_URL}/thumbnail/${item?.product?.id}/${item?.product?.featuredImage}`} />
                                                        <div className="flex gap-2 items-center">
                                                            <span className="text-sm">
                                                                {item?.title}
                                                            </span>
                                                            <span className="text-xs">
                                                                ({item?.sku})
                                                            </span>
                                                        </div>
                                                        <div className="flex gap-2 items-center">
                                                            <div className="flex gap-1 items-center dark:bg-gray-700 bg-gray-100 px-2 py-1 rounded-lg text-xs">
                                                                <span>{item.quantity}</span>
                                                                <span>عدد</span>
                                                            </div>
                                                            <a target="_blank" href={`${process.env.REACT_APP_SITE_URL}?p=${item.productId}`}>
                                                                <RxExternalLink size={18} color="blue" />
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-1 mx-2">
                                                        <span>وزن: </span>
                                                        <span className="mx-1 text-sm">
                                                            {
                                                                item?.product?.weight ? item?.product?.weight + " گرم " : "وارد نشده"
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                    }
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle={parcelData ? "پرینت رسید پستی" : packageSize ? "ثبت بارکد" : false}
                        isLoading={barcodeLoading}
                        acceptHandle={async () => {
                            if (parcelData) {
                                // print parcel receipt
                                reactToPrintParcelFn()
                            } else {
                                // submit parcel
                                try {
                                    setBarcodeLoading(true)
                                    setTimeout(() => {
                                        setBarcodeLoading(false);
                                        setIsBarcodeModalOpen(false)
                                    }, 1000);
                                    let result = await post("/epost/parcel/submit", {
                                        "orderData": {
                                            ...rowData,
                                            email: rowData.email || `${rowData.phoneNumber}@gmail.com`,
                                            packageSize: packageSize || 1
                                        }
                                    })
                                    notify(result.message, result.success == true ? "success" : "error")
                                    if (result.success) {
                                        setParcelData(result.body);
                                        post(`/sendSMS/${convertToIranLocalNumber(rowData.phoneNumber)}/332507`, {
                                            args: [rowData.fullName, result?.body?.ParcelCode]
                                        })
                                    }
                                } catch (error) {

                                } finally {

                                }

                            }
                        }}
                        isCompact={true}
                        rejectTitle="بستن"
                        rejectHandle={() => {
                            setIsBarcodeModalOpen(false);
                        }}
                    />
                </ModalFooter>
            </Modal>
            <Formik
                enableReinitialize
                initialValues={{
                    postcode: rowData?.postcode
                }}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        setIsLoading(true)
                        let response = await put(`/orders/${rowData?.id}`, {
                            newPostcode: (values.postcode).toString(),
                        })

                        notify("تغییرات با موفقیت ذخیره شد", "success")
                        setOrders(orders.map(order => {
                            if (order.id == rowData.id) {
                                return {
                                    ...order,
                                    postcode: values.postcode,
                                }
                            } else {
                                return {
                                    ...order
                                }
                            }
                        }))
                    } catch (error) {
                        notify(error.message, "error")
                    } finally {
                        setIsEditAddressModalOpen(false)
                        setIsLoading(false)

                    }

                }}
            >
                {({ values, errors, touched, setFieldValue }) => (
                    <Form>
                        <Modal isOpen={isEditAddressModalOpen} toggle={setIsEditAddressModalOpen}>
                            <ModalHeader>
                                ویرایش آدرس سفارش
                            </ModalHeader>
                            <ModalBody>
                                <div className="p-4">
                                    <div className="flex flex-col bg-white dark:bg-black rounded-2xl">
                                        <div className="flex flex-col gap-5">
                                            <div className="flex flex-col xl:grid gap-5 gap-y-7 grid-cols-2  w-full justify-center">
                                                <div className="xl:col-span-2">
                                                    <FormikField
                                                        type="number"
                                                        inputName="postcode"
                                                        label="کد پستی"
                                                        placeholder="کد پستی 10 رقمی را وارد کنید"
                                                        errors={errors}
                                                        setFieldValue={setFieldValue}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <TwinButton
                                    isCompact
                                    rejectHandle={() => { setIsEditAddressModalOpen(false) }}
                                    isLoading={isLoading}
                                />
                            </ModalFooter>
                        </Modal>
                    </Form>
                )}
            </Formik>
            <Modal isOpen={isNoteModalOpen} toggle={setIsNoteModalOpen}>
                <ModalHeader>
                    یادداشت های سیستمی سفارش
                </ModalHeader>
                <ModalBody>

                    {
                        noteData
                            ?
                            <div className="grid grid-cols-2 gap-4 p-4">
                                {noteData.map((note, index) => {
                                    return (
                                        <div class="w-full bg-yellow-200 shadow-lg rounded-lg p-4 font-handwriting text-gray-800 relative transform rotate-1">
                                            <h6 class="font-bold mb-2">یادداشت - {note.user ? note?.user?.firstName + " " + note?.user?.lastName : "سیستمی"} - {moment
                                                .from(note?.createdAt, "en", "YYYY-MM-DD HH:mm:ss")
                                                .locale("fa")
                                                .format("jYYYY/jMM/jDD HH:mm")}</h6>
                                            <p class="text-sm leading-relaxed text-right">
                                                <div dangerouslySetInnerHTML={{ __html: note?.note }} />
                                            </p>
                                            <div class="flex justify-center items-center w-8 h-8 bg-yellow-300 rounded-full absolute -top-2 -right-2 border-2 border-yellow-400 shadow-md">{index + 1}</div>
                                        </div>
                                    )

                                })}
                            </div>
                            :
                            <div className="w-full flex justify-center items-center">
                                <Spinner />
                            </div>
                    }

                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        rejectHandle={() => { setIsNoteModalOpen(false) }}
                        isCompact
                        rejectTitle='بستن'
                        acceptTitle={false}
                    />
                </ModalFooter>
            </Modal>
        </>
    )
}
